// ============================================================================
// LOT ACQUISITION TEMPLATE — ~48 default items, 4 phases
// Source: WBS Reference Section 3
// ============================================================================
export const LOT_ACQUISITION_TEMPLATE = [
  // Phase 1: Pre-Acquisition / Site Identification
  { refId: "la_p1", name: "Pre-Acquisition / Site Identification", isPhase: true },
  { refId: "la_1", name: "Comparable lot sales analysis / lot valuation", parentRefId: "la_p1" },
  { refId: "la_2", name: "Preliminary site visit and visual inspection", parentRefId: "la_p1" },
  { refId: "la_3", name: "Preliminary zoning verification", parentRefId: "la_p1" },
  { refId: "la_4", name: "Preliminary utility availability inquiry", parentRefId: "la_p1" },
  { refId: "la_5", name: "Purchase and sale agreement execution", parentRefId: "la_p1" },
  { refId: "la_6", name: "Earnest money deposit", parentRefId: "la_p1" },

  // Phase 2: Due Diligence
  { refId: "la_p2", name: "Due Diligence", isPhase: true },
  { refId: "la_7", name: "Title search / commitment review", parentRefId: "la_p2" },
  { refId: "la_8", name: "Schedule B exception review (easements, covenants, liens)", parentRefId: "la_p2" },
  { refId: "la_9", name: "Deed restriction analysis", parentRefId: "la_p2" },
  { refId: "la_10", name: "Tax lien and special assessment search", parentRefId: "la_p2" },
  { refId: "la_11", name: "Boundary survey", parentRefId: "la_p2" },
  { refId: "la_12", name: "Topographic survey", parentRefId: "la_p2" },
  { refId: "la_13", name: "Easement location mapping", parentRefId: "la_p2" },
  { refId: "la_14", name: "Flood zone determination (FEMA)", parentRefId: "la_p2" },
  { refId: "la_15", name: "Setback / building envelope verification", parentRefId: "la_p2" },
  { refId: "la_16", name: "Phase I Environmental Site Assessment", parentRefId: "la_p2" },
  { refId: "la_17", name: "Geotechnical / soils report", parentRefId: "la_p2" },
  { refId: "la_18", name: "Zoning verification letter", parentRefId: "la_p2" },
  { refId: "la_19", name: "Zoning code review (setbacks, height, coverage, FAR)", parentRefId: "la_p2" },
  { refId: "la_20", name: "Minimum lot size / buildable area confirmation", parentRefId: "la_p2" },
  { refId: "la_21", name: "Water availability / will-serve letter", parentRefId: "la_p2" },
  { refId: "la_22", name: "Sewer availability / will-serve letter", parentRefId: "la_p2" },
  { refId: "la_23", name: "Electric service confirmation", parentRefId: "la_p2" },
  { refId: "la_24", name: "Gas availability confirmation", parentRefId: "la_p2" },
  { refId: "la_25", name: "Stormwater requirements review", parentRefId: "la_p2" },
  { refId: "la_26", name: "Appraisal", parentRefId: "la_p2" },
  { refId: "la_27", name: "Impact fee estimate", parentRefId: "la_p2" },
  { refId: "la_28", name: "Utility tap/connection fee estimate", parentRefId: "la_p2" },
  { refId: "la_29", name: "Permit fee schedule review", parentRefId: "la_p2" },

  // Phase 3: Closing / Acquisition
  { refId: "la_p3", name: "Closing / Acquisition", isPhase: true },
  { refId: "la_30", name: "Due diligence resolution / PSA amendment", parentRefId: "la_p3" },
  { refId: "la_31", name: "Title insurance commitment final review", parentRefId: "la_p3" },
  { refId: "la_32", name: "Owner's title insurance policy", parentRefId: "la_p3" },
  { refId: "la_33", name: "Loan closing documents", parentRefId: "la_p3" },
  { refId: "la_34", name: "Settlement statement review", parentRefId: "la_p3" },
  { refId: "la_35", name: "Deed recording", parentRefId: "la_p3" },
  { refId: "la_36", name: "Property insurance binding", parentRefId: "la_p3" },

  // Phase 4: Entitlement & Permitting
  { refId: "la_p4", name: "Entitlement & Permitting", isPhase: true },
  { refId: "la_37", name: "Architectural plans / house plans", parentRefId: "la_p4" },
  { refId: "la_38", name: "Site plan / plot plan preparation", parentRefId: "la_p4" },
  { refId: "la_39", name: "Grading/drainage plan", parentRefId: "la_p4" },
  { refId: "la_40", name: "Structural engineering", parentRefId: "la_p4" },
  { refId: "la_41", name: "Energy code compliance documentation", parentRefId: "la_p4" },
  { refId: "la_42", name: "Building permit application", parentRefId: "la_p4" },
  { refId: "la_43", name: "Plan review", parentRefId: "la_p4" },
  { refId: "la_44", name: "Plan review comments / resubmittal", parentRefId: "la_p4" },
  { refId: "la_45", name: "Building permit issuance", parentRefId: "la_p4" },
  { refId: "la_46", name: "Building permit fees", parentRefId: "la_p4" },
  { refId: "la_47", name: "Plan review fees", parentRefId: "la_p4" },
  { refId: "la_48", name: "Impact fees (transportation)", parentRefId: "la_p4" },
  { refId: "la_49", name: "Water tap/connection fee", parentRefId: "la_p4" },
  { refId: "la_50", name: "Sewer tap/connection fee", parentRefId: "la_p4" },
];

// Backward-compatible alias
export const LAND_TEMPLATE = LOT_ACQUISITION_TEMPLATE;

// ============================================================================
// SPEC BUILD TEMPLATE — ~89 default items, 10 phases
// Source: WBS Reference Section 1
// ============================================================================
export const SPEC_BUILD_TEMPLATE = [
  // Phase 1: Pre-Construction
  { refId: "sb_p1", name: "Pre-Construction", isPhase: true },
  { refId: "sb_1", name: "Construction documents / plan set", parentRefId: "sb_p1" },
  { refId: "sb_2", name: "Structural engineering", parentRefId: "sb_p1" },
  { refId: "sb_3", name: "Civil engineering / site plan", parentRefId: "sb_p1" },
  { refId: "sb_4", name: "Building permit application & approval", parentRefId: "sb_p1" },
  { refId: "sb_5", name: "Grading permit application & approval", parentRefId: "sb_p1" },
  { refId: "sb_6", name: "Energy code compliance documentation", parentRefId: "sb_p1" },

  // Phase 2: Site Work
  { refId: "sb_p2", name: "Site Work", isPhase: true },
  { refId: "sb_7", name: "Lot clearing & tree removal", parentRefId: "sb_p2" },
  { refId: "sb_8", name: "Erosion / sediment control installation", parentRefId: "sb_p2" },
  { refId: "sb_9", name: "Rough grading", parentRefId: "sb_p2" },
  { refId: "sb_10", name: "Excavation for foundation", parentRefId: "sb_p2" },
  { refId: "sb_11", name: "Temporary utilities (power pole, water)", parentRefId: "sb_p2" },
  { refId: "sb_12", name: "Construction entrance / access road", parentRefId: "sb_p2" },

  // Phase 3: Foundation
  { refId: "sb_p3", name: "Foundation", isPhase: true },
  { refId: "sb_13", name: "Footing layout & excavation", parentRefId: "sb_p3" },
  { refId: "sb_14", name: "Footing rebar / reinforcing installation", parentRefId: "sb_p3" },
  { refId: "sb_15", name: "INSPECTION: Footing inspection (pre-pour)", parentRefId: "sb_p3" },
  { refId: "sb_16", name: "Footing pour", parentRefId: "sb_p3" },
  { refId: "sb_17", name: "Foundation wall construction (poured or block)", parentRefId: "sb_p3" },
  { refId: "sb_18", name: "Foundation waterproofing / dampproofing", parentRefId: "sb_p3" },
  { refId: "sb_19", name: "Foundation drain tile installation", parentRefId: "sb_p3" },
  { refId: "sb_20", name: "Slab-on-grade preparation (gravel, vapor barrier, mesh)", parentRefId: "sb_p3" },
  { refId: "sb_21", name: "INSPECTION: Slab pre-pour inspection", parentRefId: "sb_p3" },
  { refId: "sb_22", name: "Slab-on-grade pour", parentRefId: "sb_p3" },
  { refId: "sb_23", name: "Foundation backfill", parentRefId: "sb_p3" },
  { refId: "sb_24", name: "INSPECTION: Foundation inspection", parentRefId: "sb_p3" },

  // Phase 4: Framing
  { refId: "sb_p4", name: "Framing", isPhase: true },
  { refId: "sb_25", name: "First floor deck / joist framing", parentRefId: "sb_p4" },
  { refId: "sb_26", name: "First floor wall framing", parentRefId: "sb_p4" },
  { refId: "sb_27", name: "Second floor deck / joist framing (if applicable)", parentRefId: "sb_p4" },
  { refId: "sb_28", name: "Second floor wall framing (if applicable)", parentRefId: "sb_p4" },
  { refId: "sb_29", name: "Roof truss setting / delivery", parentRefId: "sb_p4" },
  { refId: "sb_30", name: "Roof sheathing", parentRefId: "sb_p4" },
  { refId: "sb_31", name: "Wall sheathing", parentRefId: "sb_p4" },
  { refId: "sb_32", name: "INSPECTION: Framing / structural inspection", parentRefId: "sb_p4" },

  // Phase 5: Roofing & Exterior Enclosure
  { refId: "sb_p5", name: "Roofing & Exterior Enclosure", isPhase: true },
  { refId: "sb_33", name: "House wrap / weather-resistant barrier", parentRefId: "sb_p5" },
  { refId: "sb_34", name: "Roof underlayment", parentRefId: "sb_p5" },
  { refId: "sb_35", name: "Roof shingle / finish roofing", parentRefId: "sb_p5" },
  { refId: "sb_36", name: "Roof flashing & valleys", parentRefId: "sb_p5" },
  { refId: "sb_37", name: "Window installation", parentRefId: "sb_p5" },
  { refId: "sb_38", name: "Exterior door installation (entry, sliding, garage)", parentRefId: "sb_p5" },
  { refId: "sb_39", name: "Exterior wall cladding (siding, stucco, or brick)", parentRefId: "sb_p5" },
  { refId: "sb_40", name: "Exterior trim", parentRefId: "sb_p5" },
  { refId: "sb_41", name: "Soffit & fascia", parentRefId: "sb_p5" },
  { refId: "sb_42", name: "Gutters & downspouts", parentRefId: "sb_p5" },

  // Phase 6: Major Systems Rough-Ins
  { refId: "sb_p6", name: "Major Systems Rough-Ins", isPhase: true },
  { refId: "sb_43", name: "Plumbing supply rough-in", parentRefId: "sb_p6" },
  { refId: "sb_44", name: "Plumbing DWV rough-in", parentRefId: "sb_p6" },
  { refId: "sb_45", name: "Plumbing gas line rough-in", parentRefId: "sb_p6" },
  { refId: "sb_46", name: "Water heater rough-in", parentRefId: "sb_p6" },
  { refId: "sb_47", name: "INSPECTION: Plumbing rough-in inspection", parentRefId: "sb_p6" },
  { refId: "sb_48", name: "HVAC ductwork installation", parentRefId: "sb_p6" },
  { refId: "sb_49", name: "HVAC equipment rough-in", parentRefId: "sb_p6" },
  { refId: "sb_50", name: "Exhaust / ventilation fan rough-in", parentRefId: "sb_p6" },
  { refId: "sb_51", name: "INSPECTION: Mechanical / HVAC rough-in inspection", parentRefId: "sb_p6" },
  { refId: "sb_52", name: "Main electrical service panel", parentRefId: "sb_p6" },
  { refId: "sb_53", name: "Electrical rough-wire (branch circuits)", parentRefId: "sb_p6" },
  { refId: "sb_54", name: "INSPECTION: Electrical rough-in inspection", parentRefId: "sb_p6" },

  // Phase 7: Insulation & Drywall
  { refId: "sb_p7", name: "Insulation & Drywall", isPhase: true },
  { refId: "sb_55", name: "Air sealing / caulking (pre-insulation)", parentRefId: "sb_p7" },
  { refId: "sb_56", name: "Batt insulation installation", parentRefId: "sb_p7" },
  { refId: "sb_57", name: "INSPECTION: Insulation / energy inspection", parentRefId: "sb_p7" },
  { refId: "sb_58", name: "Drywall hanging", parentRefId: "sb_p7" },
  { refId: "sb_59", name: "Drywall taping, mudding & finishing", parentRefId: "sb_p7" },
  { refId: "sb_60", name: "Drywall sanding & touch-up", parentRefId: "sb_p7" },

  // Phase 8: Interior Finishes
  { refId: "sb_p8", name: "Interior Finishes", isPhase: true },
  { refId: "sb_61", name: "Interior prime coat (walls, ceilings, trim)", parentRefId: "sb_p8" },
  { refId: "sb_62", name: "Walls & ceilings finish paint", parentRefId: "sb_p8" },
  { refId: "sb_63", name: "Trim finish paint", parentRefId: "sb_p8" },
  { refId: "sb_64", name: "Interior door installation", parentRefId: "sb_p8" },
  { refId: "sb_65", name: "Interior trim / casing", parentRefId: "sb_p8" },
  { refId: "sb_66", name: "Baseboard installation", parentRefId: "sb_p8" },
  { refId: "sb_67", name: "Kitchen cabinet installation", parentRefId: "sb_p8" },
  { refId: "sb_68", name: "Bathroom vanity installation", parentRefId: "sb_p8" },
  { refId: "sb_69", name: "Kitchen countertop fabrication & installation", parentRefId: "sb_p8" },
  { refId: "sb_70", name: "Bathroom countertop installation", parentRefId: "sb_p8" },
  { refId: "sb_71", name: "Tile installation", parentRefId: "sb_p8" },
  { refId: "sb_72", name: "Hardwood / LVP flooring installation", parentRefId: "sb_p8" },
  { refId: "sb_73", name: "Carpet installation", parentRefId: "sb_p8" },
  { refId: "sb_74", name: "Plumbing fixture installation", parentRefId: "sb_p8" },
  { refId: "sb_75", name: "Lighting fixture installation", parentRefId: "sb_p8" },
  { refId: "sb_76", name: "Electrical device installation (plates, covers)", parentRefId: "sb_p8" },
  { refId: "sb_77", name: "Appliance installation", parentRefId: "sb_p8" },
  { refId: "sb_78", name: "HVAC register / grille installation", parentRefId: "sb_p8" },

  // Phase 9: Exterior Finishes & Site Completion
  { refId: "sb_p9", name: "Exterior Finishes & Site Completion", isPhase: true },
  { refId: "sb_79", name: "Exterior paint / stain", parentRefId: "sb_p9" },
  { refId: "sb_80", name: "Final grading", parentRefId: "sb_p9" },
  { refId: "sb_81", name: "Driveway installation", parentRefId: "sb_p9" },
  { refId: "sb_82", name: "Sidewalk / walkway", parentRefId: "sb_p9" },
  { refId: "sb_83", name: "Landscaping (topsoil, seeding/sod)", parentRefId: "sb_p9" },

  // Phase 10: Final / Closeout
  { refId: "sb_p10", name: "Final / Closeout", isPhase: true },
  { refId: "sb_84", name: "Water service connection / meter", parentRefId: "sb_p10" },
  { refId: "sb_85", name: "Sewer / septic connection", parentRefId: "sb_p10" },
  { refId: "sb_86", name: "Electrical service connection / meter set", parentRefId: "sb_p10" },
  { refId: "sb_87", name: "Final plumbing trim & connection check", parentRefId: "sb_p10" },
  { refId: "sb_88", name: "Final electrical trim & check", parentRefId: "sb_p10" },
  { refId: "sb_89", name: "Final HVAC commissioning & startup", parentRefId: "sb_p10" },
  { refId: "sb_90", name: "INSPECTION: Final plumbing inspection", parentRefId: "sb_p10" },
  { refId: "sb_91", name: "INSPECTION: Final electrical inspection", parentRefId: "sb_p10" },
  { refId: "sb_92", name: "INSPECTION: Final mechanical inspection", parentRefId: "sb_p10" },
  { refId: "sb_93", name: "Rough clean", parentRefId: "sb_p10" },
  { refId: "sb_94", name: "Final professional clean", parentRefId: "sb_p10" },
  { refId: "sb_95", name: "Punch list walkthrough (builder)", parentRefId: "sb_p10" },
  { refId: "sb_96", name: "Punch list corrections", parentRefId: "sb_p10" },
  { refId: "sb_97", name: "Paint touch-up (post-flooring)", parentRefId: "sb_p10" },
  { refId: "sb_98", name: "INSPECTION: Final building inspection", parentRefId: "sb_p10" },
  { refId: "sb_99", name: "Certificate of Occupancy", parentRefId: "sb_p10" },
];

// ============================================================================
// CUSTOM HOME TEMPLATE — ~111 default items, 10 phases
// Source: WBS Reference Section 2
// ============================================================================
export const CUSTOM_HOME_TEMPLATE = [
  // Phase 1: Pre-Construction / Design & Planning
  { refId: "ch_p1", name: "Pre-Construction / Design & Planning", isPhase: true },
  { refId: "ch_1", name: "Architectural design & construction documents", parentRefId: "ch_p1" },
  { refId: "ch_2", name: "Structural engineering", parentRefId: "ch_p1" },
  { refId: "ch_3", name: "Civil engineering / site plan", parentRefId: "ch_p1" },
  { refId: "ch_4", name: "Geotechnical / soils report", parentRefId: "ch_p1" },
  { refId: "ch_5", name: "Land survey & boundary staking", parentRefId: "ch_p1" },
  { refId: "ch_6", name: "Building permit application & approval", parentRefId: "ch_p1" },
  { refId: "ch_7", name: "Grading permit application & approval", parentRefId: "ch_p1" },
  { refId: "ch_8", name: "Energy code compliance documentation", parentRefId: "ch_p1" },

  // Phase 2: Site Work
  { refId: "ch_p2", name: "Site Work", isPhase: true },
  { refId: "ch_9", name: "Lot clearing & tree removal", parentRefId: "ch_p2" },
  { refId: "ch_10", name: "Topsoil stripping & stockpiling", parentRefId: "ch_p2" },
  { refId: "ch_11", name: "Erosion / sediment control installation", parentRefId: "ch_p2" },
  { refId: "ch_12", name: "Rough grading", parentRefId: "ch_p2" },
  { refId: "ch_13", name: "Excavation for foundation", parentRefId: "ch_p2" },
  { refId: "ch_14", name: "Construction entrance / access road", parentRefId: "ch_p2" },

  // Phase 3: Foundation
  { refId: "ch_p3", name: "Foundation", isPhase: true },
  { refId: "ch_15", name: "Footing layout & excavation", parentRefId: "ch_p3" },
  { refId: "ch_16", name: "Footing rebar / reinforcing installation", parentRefId: "ch_p3" },
  { refId: "ch_17", name: "INSPECTION: Footing inspection (pre-pour)", parentRefId: "ch_p3" },
  { refId: "ch_18", name: "Footing pour", parentRefId: "ch_p3" },
  { refId: "ch_19", name: "Foundation wall construction (poured or block)", parentRefId: "ch_p3" },
  { refId: "ch_20", name: "Foundation waterproofing / dampproofing", parentRefId: "ch_p3" },
  { refId: "ch_21", name: "Foundation drain tile installation", parentRefId: "ch_p3" },
  { refId: "ch_22", name: "Foundation backfill", parentRefId: "ch_p3" },
  { refId: "ch_23", name: "Slab-on-grade preparation (gravel, vapor barrier, mesh)", parentRefId: "ch_p3" },
  { refId: "ch_24", name: "INSPECTION: Slab pre-pour inspection", parentRefId: "ch_p3" },
  { refId: "ch_25", name: "Slab-on-grade pour", parentRefId: "ch_p3" },
  { refId: "ch_26", name: "Anchor bolts / foundation hardware", parentRefId: "ch_p3" },
  { refId: "ch_27", name: "INSPECTION: Foundation inspection", parentRefId: "ch_p3" },

  // Phase 4: Framing
  { refId: "ch_p4", name: "Framing", isPhase: true },
  { refId: "ch_28", name: "Structural steel setting", parentRefId: "ch_p4" },
  { refId: "ch_29", name: "First floor deck / joist framing", parentRefId: "ch_p4" },
  { refId: "ch_30", name: "First floor wall framing", parentRefId: "ch_p4" },
  { refId: "ch_31", name: "Second floor deck / joist framing", parentRefId: "ch_p4" },
  { refId: "ch_32", name: "Second floor wall framing", parentRefId: "ch_p4" },
  { refId: "ch_33", name: "Roof truss setting / delivery", parentRefId: "ch_p4" },
  { refId: "ch_34", name: "Roof framing (stick-framed rafters)", parentRefId: "ch_p4" },
  { refId: "ch_35", name: "Roof sheathing", parentRefId: "ch_p4" },
  { refId: "ch_36", name: "Wall sheathing", parentRefId: "ch_p4" },
  { refId: "ch_37", name: "Window & exterior door installation", parentRefId: "ch_p4" },
  { refId: "ch_38", name: "INSPECTION: Framing / structural inspection", parentRefId: "ch_p4" },

  // Phase 5: Roofing & Exterior Enclosure
  { refId: "ch_p5", name: "Roofing & Exterior Enclosure", isPhase: true },
  { refId: "ch_39", name: "House wrap / weather-resistant barrier", parentRefId: "ch_p5" },
  { refId: "ch_40", name: "Roof underlayment", parentRefId: "ch_p5" },
  { refId: "ch_41", name: "Roof shingle / finish roofing", parentRefId: "ch_p5" },
  { refId: "ch_42", name: "Roof flashing & valleys", parentRefId: "ch_p5" },
  { refId: "ch_43", name: "Exterior wall cladding (siding, stucco, or brick)", parentRefId: "ch_p5" },
  { refId: "ch_44", name: "Exterior trim", parentRefId: "ch_p5" },
  { refId: "ch_45", name: "Soffit & fascia", parentRefId: "ch_p5" },
  { refId: "ch_46", name: "Gutters & downspouts", parentRefId: "ch_p5" },
  { refId: "ch_47", name: "Window installation (final setting/flashing)", parentRefId: "ch_p5" },
  { refId: "ch_48", name: "Exterior door installation (entry, sliding, garage)", parentRefId: "ch_p5" },

  // Phase 6: Major Systems Rough-Ins
  { refId: "ch_p6", name: "Major Systems Rough-Ins", isPhase: true },
  { refId: "ch_49", name: "Plumbing supply rough-in", parentRefId: "ch_p6" },
  { refId: "ch_50", name: "Plumbing DWV rough-in", parentRefId: "ch_p6" },
  { refId: "ch_51", name: "Plumbing gas line rough-in", parentRefId: "ch_p6" },
  { refId: "ch_52", name: "Water heater rough-in", parentRefId: "ch_p6" },
  { refId: "ch_53", name: "INSPECTION: Plumbing rough-in inspection", parentRefId: "ch_p6" },
  { refId: "ch_54", name: "HVAC ductwork installation", parentRefId: "ch_p6" },
  { refId: "ch_55", name: "HVAC equipment rough-in", parentRefId: "ch_p6" },
  { refId: "ch_56", name: "HVAC refrigerant line rough-in", parentRefId: "ch_p6" },
  { refId: "ch_57", name: "Exhaust / ventilation fan rough-in", parentRefId: "ch_p6" },
  { refId: "ch_58", name: "INSPECTION: Mechanical / HVAC rough-in inspection", parentRefId: "ch_p6" },
  { refId: "ch_59", name: "Main electrical service panel", parentRefId: "ch_p6" },
  { refId: "ch_60", name: "Electrical rough-wire (branch circuits)", parentRefId: "ch_p6" },
  { refId: "ch_61", name: "Electrical box / outlet / switch placement", parentRefId: "ch_p6" },
  { refId: "ch_62", name: "Electrical walk-through (owner placement verification)", parentRefId: "ch_p6" },
  { refId: "ch_63", name: "INSPECTION: Electrical rough-in inspection", parentRefId: "ch_p6" },
  { refId: "ch_64", name: "Low-voltage / structured wiring rough-in", parentRefId: "ch_p6" },
  { refId: "ch_65", name: "Security / alarm rough-in", parentRefId: "ch_p6" },
  { refId: "ch_66", name: "EV charger circuit rough-in", parentRefId: "ch_p6" },

  // Phase 7: Insulation & Drywall
  { refId: "ch_p7", name: "Insulation & Drywall", isPhase: true },
  { refId: "ch_67", name: "Air sealing / caulking (pre-insulation)", parentRefId: "ch_p7" },
  { refId: "ch_68", name: "Draft stopping / fire stopping", parentRefId: "ch_p7" },
  { refId: "ch_69", name: "Batt insulation installation", parentRefId: "ch_p7" },
  { refId: "ch_70", name: "INSPECTION: Insulation / energy inspection", parentRefId: "ch_p7" },
  { refId: "ch_71", name: "Drywall delivery & stocking", parentRefId: "ch_p7" },
  { refId: "ch_72", name: "Drywall hanging", parentRefId: "ch_p7" },
  { refId: "ch_73", name: "Drywall taping, mudding & finishing", parentRefId: "ch_p7" },
  { refId: "ch_74", name: "Drywall sanding", parentRefId: "ch_p7" },
  { refId: "ch_75", name: "Drywall point-up / touch-up", parentRefId: "ch_p7" },

  // Phase 8: Interior Finishes
  { refId: "ch_p8", name: "Interior Finishes", isPhase: true },
  { refId: "ch_76", name: "Drywall prime coat", parentRefId: "ch_p8" },
  { refId: "ch_77", name: "Trim prime coat", parentRefId: "ch_p8" },
  { refId: "ch_78", name: "Walls & ceilings finish coat", parentRefId: "ch_p8" },
  { refId: "ch_79", name: "Trim finish coat", parentRefId: "ch_p8" },
  { refId: "ch_80", name: "Exterior paint / stain", parentRefId: "ch_p8" },
  { refId: "ch_81", name: "Interior door installation", parentRefId: "ch_p8" },
  { refId: "ch_82", name: "Interior trim / casing", parentRefId: "ch_p8" },
  { refId: "ch_83", name: "Baseboard installation", parentRefId: "ch_p8" },
  { refId: "ch_84", name: "Crown molding", parentRefId: "ch_p8" },
  { refId: "ch_85", name: "Closet shelving / organizers", parentRefId: "ch_p8" },
  { refId: "ch_86", name: "Kitchen cabinet installation", parentRefId: "ch_p8" },
  { refId: "ch_87", name: "Bathroom vanity installation", parentRefId: "ch_p8" },
  { refId: "ch_88", name: "Kitchen countertop fabrication & installation", parentRefId: "ch_p8" },
  { refId: "ch_89", name: "Bathroom countertop installation", parentRefId: "ch_p8" },
  { refId: "ch_90", name: "Ceramic / porcelain tile installation", parentRefId: "ch_p8" },
  { refId: "ch_91", name: "Hardwood floor installation", parentRefId: "ch_p8" },
  { refId: "ch_92", name: "Hardwood floor sanding, staining & sealing", parentRefId: "ch_p8" },
  { refId: "ch_93", name: "Carpet installation", parentRefId: "ch_p8" },
  { refId: "ch_94", name: "Vinyl / LVP flooring installation", parentRefId: "ch_p8" },
  { refId: "ch_95", name: "Plumbing fixture installation", parentRefId: "ch_p8" },
  { refId: "ch_96", name: "Lighting fixture installation", parentRefId: "ch_p8" },
  { refId: "ch_97", name: "Appliance installation", parentRefId: "ch_p8" },
  { refId: "ch_98", name: "Electrical device installation (plates, covers)", parentRefId: "ch_p8" },
  { refId: "ch_99", name: "HVAC register / grille installation", parentRefId: "ch_p8" },
  { refId: "ch_100", name: "Door hardware installation", parentRefId: "ch_p8" },
  { refId: "ch_101", name: "Bath hardware installation", parentRefId: "ch_p8" },
  { refId: "ch_102", name: "Mirror installation", parentRefId: "ch_p8" },

  // Phase 9: Exterior Finishes & Site Completion
  { refId: "ch_p9", name: "Exterior Finishes & Site Completion", isPhase: true },
  { refId: "ch_103", name: "Final grading", parentRefId: "ch_p9" },
  { refId: "ch_104", name: "Driveway installation", parentRefId: "ch_p9" },
  { refId: "ch_105", name: "Sidewalk / walkway", parentRefId: "ch_p9" },
  { refId: "ch_106", name: "Landscaping (topsoil, seeding/sod)", parentRefId: "ch_p9" },
  { refId: "ch_107", name: "Exterior cleanup / debris removal", parentRefId: "ch_p9" },
  { refId: "ch_108", name: "Water service connection / meter", parentRefId: "ch_p9" },
  { refId: "ch_109", name: "Sewer / septic connection", parentRefId: "ch_p9" },
  { refId: "ch_110", name: "Electrical service connection / meter set", parentRefId: "ch_p9" },

  // Phase 10: Final / Closeout
  { refId: "ch_p10", name: "Final / Closeout", isPhase: true },
  { refId: "ch_111", name: "Final plumbing trim & connection check", parentRefId: "ch_p10" },
  { refId: "ch_112", name: "Final electrical trim & check", parentRefId: "ch_p10" },
  { refId: "ch_113", name: "Final HVAC commissioning & startup", parentRefId: "ch_p10" },
  { refId: "ch_114", name: "HVAC outdoor unit setting", parentRefId: "ch_p10" },
  { refId: "ch_115", name: "INSPECTION: Final plumbing inspection", parentRefId: "ch_p10" },
  { refId: "ch_116", name: "INSPECTION: Final electrical inspection", parentRefId: "ch_p10" },
  { refId: "ch_117", name: "INSPECTION: Final mechanical inspection", parentRefId: "ch_p10" },
  { refId: "ch_118", name: "Rough clean", parentRefId: "ch_p10" },
  { refId: "ch_119", name: "Final professional clean", parentRefId: "ch_p10" },
  { refId: "ch_120", name: "Punch list walkthrough (builder)", parentRefId: "ch_p10" },
  { refId: "ch_121", name: "Punch list corrections", parentRefId: "ch_p10" },
  { refId: "ch_122", name: "Owner walkthrough / orientation", parentRefId: "ch_p10" },
  { refId: "ch_123", name: "Paint touch-up (post-flooring)", parentRefId: "ch_p10" },
  { refId: "ch_124", name: "INSPECTION: Final building inspection", parentRefId: "ch_p10" },
  { refId: "ch_125", name: "Certificate of Occupancy", parentRefId: "ch_p10" },
];

// Backward-compatible alias — defaults to Spec Build for existing import references
export const CONSTRUCTION_TEMPLATE = SPEC_BUILD_TEMPLATE;

// ============================================================================
// TASK LIBRARY — organized by construction phase + extended categories
// Source: WBS Reference Sections 1-4 (LIBRARY-ONLY items), Section 6, Section 7
// ============================================================================
export const TASK_LIBRARY = [
  {
    category: "Pre-Construction",
    tasks: [
      "Geotechnical / soils report",
      "HOA / Architectural Review Board approval",
      "Environmental / wetlands assessment",
      "Septic system design",
      "Well permit",
      "Energy modeling / HERS pre-assessment",
      "Interior design / selections coordination",
      "Landscape design",
      "Pool / outdoor living design",
    ],
  },
  {
    category: "Site Work",
    tasks: [
      "Topsoil stripping & stockpiling",
      "Stormwater management installation",
      "Retaining wall construction",
      "Rock removal / blasting",
      "Temporary utilities (power pole, water)",
      "Dewatering",
      "Tree protection fencing",
      "Import / export fill material",
    ],
  },
  {
    category: "Foundation",
    tasks: [
      "Termite pre-treatment (sub-slab)",
      "Radon mitigation rough-in (sub-slab piping)",
      "Plumbing sub-slab rough-in",
      "INSPECTION: Under-slab plumbing inspection",
      "Basement slab preparation & pour",
      "Garage slab preparation & pour",
      "Structural steel columns / lintels at foundation",
      "Elevator pit construction",
    ],
  },
  {
    category: "Framing",
    tasks: [
      "Staircase framing",
      "Porch / covered entry framing",
      "Shear wall / hold-down hardware",
      "Basement framing (interior partitions)",
      "Dormer framing",
      "Metal connectors & structural hardware",
      "Balcony / cantilever framing",
      "Detached garage framing",
    ],
  },
  {
    category: "Roofing & Exterior",
    tasks: [
      "Brick / stone veneer masonry",
      "Metal roofing",
      "Skylights / roof windows",
      "Chimney construction / flue",
      "Exterior column / post wraps",
      "Exterior shutters",
      "Specialty cladding (cedar shake, composite)",
    ],
  },
  {
    category: "Major Systems Rough-Ins",
    tasks: [
      "Low-voltage / structured wiring rough-in",
      "Security / alarm rough-in",
      "EV charger circuit rough-in",
      "Radiant floor heating rough-in",
      "Water treatment / softener rough-in",
      "Outdoor plumbing rough-in",
      "Zoned HVAC rough-in",
      "ERV / HRV rough-in",
      "Whole-house humidifier/dehumidifier rough-in",
      "Mini-split line set rough-in",
      "Geothermal loop rough-in",
      "Audio/visual system rough-in",
      "Central vacuum rough-in",
      "Generator transfer switch rough-in",
      "Solar PV conduit / junction box rough-in",
    ],
  },
  {
    category: "Insulation & Drywall",
    tasks: [
      "Blown-in insulation (attic)",
      "Spray foam insulation",
      "Draft stopping / fire stopping",
      "Rigid board insulation (exterior continuous)",
      "Soundproofing / acoustic insulation",
      "Garage ceiling drywall (fire-rated)",
    ],
  },
  {
    category: "Interior Finishes",
    tasks: [
      "Closet shelving / organizers",
      "Crown molding",
      "Door hardware installation",
      "Bath hardware installation",
      "Mirror installation",
      "Shower door / enclosure",
      "Garage floor coating",
      "Accent walls / specialty finishes",
      "Cabinet painting/staining",
      "Wainscoting / wall paneling",
      "Built-in shelving / bookcases",
      "Coffered / tray ceiling trim",
      "Staircase railings / balusters",
      "Fireplace mantel / surround",
      "Butler's pantry cabinetry",
      "Laundry room cabinetry",
      "Natural stone flooring",
      "Heated floor mat (under tile)",
      "Fireplace installation",
      "Specialty appliances",
      "Garbage disposal",
      "Whole-house water filtration",
      "Window treatments",
      "Medicine cabinet",
      "Water heater final installation",
      "Garage cabinetry",
    ],
  },
  {
    category: "Exterior & Site Completion",
    tasks: [
      "Deck construction",
      "Patio / hardscape",
      "Porch / screened porch",
      "Fence installation",
      "Irrigation system",
      "Landscape planting",
      "Outdoor lighting",
      "Mailbox",
      "Pool / spa",
      "Outdoor kitchen",
      "Gas service connection",
      "Cable / fiber service connection",
    ],
  },
  {
    category: "Final / Closeout",
    tasks: [
      "Marketing photos / staging",
      "Third-party home inspection",
      "HERS rating / energy certification",
      "Security system commissioning",
      "Smart home system commissioning",
      "Pool inspection",
      "As-built survey",
      "Warranty documentation package",
      "Homeowner manual delivery",
    ],
  },
  {
    category: "Extended Inspections",
    tasks: [
      "INSPECTION: Notice of Commencement recording",
      "INSPECTION: Pre-construction conference (mandatory meeting)",
      "INSPECTION: Setback inspection",
      "INSPECTION: Flood zone elevation certificate (pre-construction)",
      "INSPECTION: Post-tension slab inspection",
      "INSPECTION: Third-party engineer foundation inspection",
      "INSPECTION: Stem wall inspection (CMU block)",
      "INSPECTION: Tie-beam inspection (CMU block)",
      "INSPECTION: Lintel inspection (CMU block)",
      "INSPECTION: Fill cell inspection (masonry lifts)",
      "INSPECTION: Hold-down / anchor bolt verification",
      "INSPECTION: Termite soil treatment inspection (pre-slab)",
      "INSPECTION: Foundation survey (surveyor verification)",
      "INSPECTION: Radon-resistant construction verification",
      "INSPECTION: Sheathing inspection (high-wind zones)",
      "INSPECTION: Exterior shear wall inspection",
      "INSPECTION: Braced wall panel inspection",
      "INSPECTION: Hurricane strap / tie-down inspection",
      "INSPECTION: Brick ties inspection",
      "INSPECTION: Structural observation by engineer of record",
      "INSPECTION: Wind storm inspection (coastal areas)",
      "INSPECTION: Gas line air test",
      "INSPECTION: Sewer line inspection",
      "INSPECTION: Water service inspection",
      "INSPECTION: Mechanical cover inspection",
      "INSPECTION: Residential fire sprinkler rough inspection",
      "INSPECTION: EV charging ready rough-in verification",
      "INSPECTION: Solar PV conduit rough-in inspection",
      "INSPECTION: Dry-in inspection (air/moisture/windows)",
      "INSPECTION: Exterior lath inspection (stucco)",
      "INSPECTION: Scratch coat inspection (stucco)",
      "INSPECTION: WUI inspection (wildland-urban interface)",
      "INSPECTION: Wall insulation inspection",
      "INSPECTION: Sealed / conditioned crawlspace inspection",
      "INSPECTION: Framing and air barrier continuity inspection",
      "INSPECTION: HERS QII air sealing verification",
      "INSPECTION: HERS QII insulation verification",
      "INSPECTION: Duct leakage test (rough-in stage)",
      "INSPECTION: Blower door test",
      "INSPECTION: Duct leakage test (post-construction)",
      "INSPECTION: HERS blower door test (post-construction)",
      "INSPECTION: HERS refrigerant charge verification",
      "INSPECTION: HERS HVAC airflow verification",
      "INSPECTION: HERS equipment efficiency verification",
      "INSPECTION: HERS IAQ ventilation verification",
      "INSPECTION: Residential fire sprinkler final inspection",
      "INSPECTION: Mandatory solar PV system inspection",
      "INSPECTION: Solar fire safety pathway verification",
      "INSPECTION: Battery storage readiness inspection",
      "INSPECTION: Green building / sustainability verification",
      "INSPECTION: Energy compliance certificate posting",
      "INSPECTION: Termite final certificate",
      "INSPECTION: Flood zone elevation certificate (final)",
      "INSPECTION: Third-party special inspection agency report",
      "INSPECTION: Energy code progress inspection report",
      "INSPECTION: Private provider inspection",
      "INSPECTION: Stormwater / erosion control final inspection",
    ],
  },
  {
    category: "Specialty Construction",
    tasks: [
      "Elevator installation",
      "Wine cellar construction",
      "Safe room / storm shelter",
      "Theater room acoustic treatment",
      "Outdoor fireplace / fire pit",
      "Outdoor shower",
      "Dog wash station",
      "Whole-house generator installation",
      "Solar PV panel installation",
      "Battery storage system installation",
      "Residential fire sprinkler system",
      "Backup sump pump installation",
      "Whole-house water filtration system",
      "Water well drilling",
      "Septic system installation",
    ],
  },
  {
    category: "General / Cross-Phase",
    tasks: [
      "Owner allowance selection deadline",
      "Material lead time tracking",
      "Change order documentation",
      "Progress draw request",
      "Lien waiver collection",
      "Weekly job site meeting",
      "Safety inspection",
      "Temporary fencing",
      "Job site signage",
      "Portable toilet delivery/service",
      "Dumpster delivery/swap",
    ],
  },
  {
    category: "Lot Acquisition",
    tasks: [
      "Phase II Environmental Site Assessment",
      "Wetlands delineation",
      "Percolation test (if septic)",
      "Radon testing",
      "Slope stability analysis",
      "Comprehensive plan review",
      "Overlay district review",
      "Variance assessment",
      "Utility tap location identification",
      "Property tax verification",
      "Endangered species screening",
      "Stormwater/erosion control plan",
      "Grading/land disturbance permit",
      "Electric/gas connection fees",
    ],
  },
];

// Canonical task status enum. STATUS_COLORS keys are derived from this.
export const TASK_STATUSES = [
  "Not Started",
  "In Progress",
  "Pending Approval",
  "Complete",
  "Blocked",
];

export const STATUS_COLORS = {
  "Not Started": "bg-gray-100 text-gray-600",
  "In Progress": "bg-blue-100 text-blue-700",
  "Pending Approval": "bg-amber-100 text-amber-700",
  "Complete": "bg-green-100 text-green-700",
  "Blocked": "bg-red-100 text-red-700",
};

export const CONTACT_TYPE_COLORS = {
  "Employee": "bg-violet-100 text-violet-700",
  "Vendor": "bg-orange-100 text-orange-700",
  "Client": "bg-teal-100 text-teal-700",
  "Seller / Agent": "bg-amber-100 text-amber-700",
  "Other / Stakeholder": "bg-slate-200 text-slate-700",
};

export const COST_CATEGORIES = [
  "Labor",
  "Materials",
  "Subcontractor",
  "Equipment",
  "Permits",
  "Overhead",
  "Other",
];
